export const checkIsNumber = (value) => typeof value === "number" && !Number.isNaN(value);
